/** The ping that accompanies a desktop notification (copied from cpanel). */
const NOTIFICATION_SOUND = '/notification-sound.mp3';

/**
 * Browsers only allow notification sound after a user gesture, so cpanel waited
 * for the first click before it would ping. Tracked per page load.
 */
let userHasInteracted = false;

if (typeof document !== 'undefined') {
  document.addEventListener(
    'click',
    () => {
      userHasInteracted = true;
    },
    { once: true },
  );
}

/**
 * Desktop notification + sound for an incoming chat message (cpanel
 * `showBrowserNotification`). The desktop notification needs granted browser
 * permission; audio also waits for a page interaction.
 */
export function showChatNotification(title: string, body: string): void {
  if (typeof Notification === 'undefined') return;
  if (Notification.permission !== 'granted') return;

  try {
    new Notification(title, { body, icon: '/favicon.svg' });
  } catch {
    // The browser can reject a notification if its permission changed mid-session.
    return;
  }

  playChatNotificationSound();
}

/** Play the chat ping when the browser allows audio after a page interaction. */
export function playChatNotificationSound(): void {
  if (!userHasInteracted) return;
  try {
    void new Audio(NOTIFICATION_SOUND).play().catch(() => undefined);
  } catch {
    // Audio is optional; the visual notification already fired.
  }
}
